export const copyToClipboard = (data: string) => {
  // this is fine since we are checking if navigator.clipboard exists in the browser
  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition, no-restricted-properties
  if (navigator.clipboard) {
    // this is fine since we are only using it if navigator.clipboard exists in the browser
    // oxlint-disable-next-line no-restricted-properties
    navigator.clipboard.writeText(data)
    return
  }
  // for the older browsers that don't support navigator.clipboard.writeText
  const textarea = document.createElement('textarea')
  textarea.value = data
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  textarea.select()
  textarea.setSelectionRange(0, textarea.value.length)
  document.execCommand('copy')
  document.body.removeChild(textarea)
}
